var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93325 7.36424H5.99325V10.6976C5.99325 11.0642 6.29325 11.3642 6.65992 11.3642H9.32659C9.69325 11.3642 9.99325 11.0642 9.99325 10.6976V7.36424H11.0533C11.6466 7.36424 11.9466 6.64424 11.5266 6.22424L8.46659 3.16424C8.20659 2.90424 7.78659 2.90424 7.52659 3.16424L4.46659 6.22424C4.04659 6.64424 4.33992 7.36424 4.93325 7.36424ZM3.33325 13.3642C3.33325 13.7309 3.63325 14.0309 3.99992 14.0309H11.9999C12.3666 14.0309 12.6666 13.7309 12.6666 13.3642C12.6666 12.9976 12.3666 12.6976 11.9999 12.6976H3.99992C3.63325 12.6976 3.33325 12.9976 3.33325 13.3642Z",
    fill: "#A5DACB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsvIcon);
export default __webpack_public_path__ + "static/media/importCSVIcon.1bbb5f693b79e982a102a4171cec3551.svg";
export { ForwardRef as ReactComponent };